import { useState, useEffect } from "react";

// @mui material components
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

interface BtnMenuProps {
  children: React.ReactNode;
  text: string;
  disabled: boolean;
}

function BtnMenu({ children, text, disabled }: BtnMenuProps): JSX.Element {
  const [menu, setMenu] = useState(null);
  const [isDisabled, setIsDisabled] = useState<boolean>(disabled);
  const openMenu = (event: any) => setMenu(event.currentTarget);
  const closeMenu = () => setMenu(null);

  useEffect(() => {
    setIsDisabled(disabled);
  }, [disabled]);

  return (
    <MDBox display="flex">
      <MDButton
        variant={menu ? "contained" : "outlined"}
        disabled={isDisabled}
        color="dark"
        onClick={openMenu}
      >
        {text}&nbsp;
        <Icon>keyboard_arrow_down</Icon>
      </MDButton>
      <Menu
        anchorEl={menu}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        open={Boolean(menu)}
        onClose={closeMenu}
        keepMounted
      >
        {children}
      </Menu>
    </MDBox>
  );
}

export default BtnMenu;
